import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query'
import { loginUser } from '../api/auth';
import { adminLink } from '../constants/endspoints';
import MessageModal from '../components/MessageModal';
import Modal from 'react-responsive-modal';
import { updateUserPassword } from '../api/user';
import { toast } from 'react-toastify';

const Account = () => {


    const {register: registerForm1, formState: { errors: errorsForm1 }, handleSubmit: handleSubmitForm1} = useForm();

    const { register: registerForm2, handleSubmit: handleSubmitForm2, formState: { errors: errorsForm2 }} = useForm();

    const [credentials, setCredentials] = useState({ email:'', password:'' })
    const [msg, setMsg] = useState(false)

    const [pwd, setPwd] = useState("") 
    const [email, setEmail] = useState("") 
    const [showPassword, setShowPassword] = useState(false)
    const [pwdSuccess, setPwdSuccess] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)


    const mutation = useMutation({
        mutationFn: (data) => loginUser(data), 
        onSuccess: () => { window.location.href = adminLink; },
        onError: () => { setMsg(true) },
    });




    
    
    
    
        // Mutation pour gérer la modification de mot de passe
    const toastUpPwd = useRef(null);
    const updatePwdMutation = useMutation({
        mutationFn: updateUserPassword,
        onMutate: ()=>{
            toastUpPwd.current = toast.loading(`Modification en cours...`, { 
                position: 'top-right',
            });
        },
        onSuccess: (res) => {
            toast.dismiss(toastUpPwd.current);
            toastUpPwd.current = toast.success(res?.data?.message, {
                isLoading: false,
                autoClose: false,
                closeOnClick: true,
            });            
            setPwdSuccess(res?.data?.message)
            toastUpPwd.current = null;
        },
        onError: (err) => {
            toast.dismiss(toastUpPwd.current);
            toastUpPwd.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
                autoClose: false,
            });
            toastUpPwd.current = null;
        },
    });

    const modifyPwd = () => {
        if (pwd === "" || email === "") {
            toast.error("Veuillez renseigner le Nouveau Mot de Passe", {
                position: 'top-right',
                autoClose: 5000,
                closeOnClick: true,
            });
            return;
        }
        updatePwdMutation.mutate({email: email, plainPassword: pwd})
    }




    return (
        <div className='text-white mb-5 mt-2 container-xxl'>
            
            <div className='d-flex justify-content-center align-items-center h-100 w-100' style={{minHeight:"70vh", maxHeight:"90vh"}}>
                <div className='w-100 border border-1 border-white p-md-3 p-2' style={{maxWidth:"576px"}}>
                    <h1 className='fs-3 fw-bold'>Se connecter</h1>

                    <form className='row justify-content-start align-items-strech was-validated'>
                        <div className='col-12 mb-2'>
                            <div className='inputBox'>
                                <input 
                                    {...registerForm1("email", {required: true })} 
                                    onChange={(e)=>setCredentials({ ...credentials, email: e.target.value })} 
                                    value={credentials.email} 
                                    type='email' 
                                    className='w-100 fs-9s rounded-0 form-control' 
                                    autoComplete='new-password' 
                                    required
                                />
                                <span>Email</span>
                                <i></i>
                            </div>
                            {errorsForm1.email && <small className="text-danger fs-7s" role="alert">Email requis</small>}
                        </div>

                        <div className='col-12 mb-2'>
                            <div className='inputBox'>
                                <input 
                                    {...registerForm1("mdp", {required: true })} 
                                    onChange={(e)=>setCredentials({ ...credentials, password: e.target.value })} 
                                    value={credentials.password} 
                                    type='password' 
                                    className='w-100 fs-9s rounded-0 form-control' 
                                    autoComplete='new-password'
                                    required
                                />
                                <span>Mot de passe</span>
                                <i></i>
                            </div>
                            {errorsForm1.mdp && <small className="text-danger fs-7s" role="alert">Mot de passe requis</small>}
                        </div>

                        <p 
                            role='button'
                            onClick={()=>setIsModalOpen(true)}
                            className='color-primary fs-9s fst-italic text-decoration-underline mb-1'
                        >
                            Mot de Passe oublié ?
                        </p>

                        <div className='mt-3'>
                            <button onClick={handleSubmitForm1(()=> mutation.mutate((credentials)))} disabled={mutation.isPending} type='submit' className='form-control w-auto rounded-0 fs-9s py-1 px-3'>
                                {mutation.isPending ? 'Patientez...' : 'Se connecter'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>



            <MessageModal 
                open={msg} 
                setOpen={setMsg} 
                message={mutation?.error?.message || 'Erreur inconnue'} 
                iconClass={"fa fa-circle-xmark text-danger"} 
                textClass={""} 
            />


            <Modal 
                open={isModalOpen} 
                onClose={()=>updatePwdMutation.isPending ? null : (setIsModalOpen(false), setPwd(""), setPwdSuccess(false))} 
                center 
                classNames={{modal:"bg-black text-white border"}} 
                closeIcon={<i className='fa fa-xmark text-white'></i>}
                focusTrapped={false}
            >

                {
                    !pwdSuccess?
                    <form className='p-4'>
                        <h2 className='fs-5 fw-bold mb-3 text-center'>Modifier le mot de passe</h2>
                        <div className='d-flex flex-column justify-content-center'>
                            <div>
                                <input 
                                    {...registerForm2("emailUpdate", {
                                        required: "Email est requis",
                                        pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                                            message: "Format d'email invalide",
                                        },
                                    })}
                                    onChange={(e)=>setEmail(e.target.value)} 
                                    value={email} 
                                    type='email' 
                                    className='form-control shadow-none bg-black fs-9s text-white py-1 px-2'
                                    placeholder='Email'
                                    autoComplete="new-password" 
                                    required
                                />
                                {errorsForm2.emailUpdate && <span className="fs-8s text-danger">{errorsForm2.emailUpdate.message}</span>}
                            </div>
                            <div className='position-relative mt-3'>
                                <input 
                                    {...registerForm2("passwordUpdate", {
                                        required: "Mot de passe requis",
                                        minLength: {
                                            value: 9,
                                            message: "Doit avoir au moins 09 caractères",
                                        },
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{9,}$/,
                                            message:
                                                "Minimun 9 caractères, 1 majuscule, 1 miniscule, 1 caractère special",
                                        },
                                    })}
                                    type={showPassword?'text':'password'} 
                                    onChange={(e)=>setPwd(e.target.value)} 
                                    value={pwd} 
                                    autoComplete="new-password"
                                    className='form-control shadow-none bg-black fs-9s text-white py-1 px-2'
                                    placeholder='Nouveau Mot de Passe'
                                />
                                <p 
                                    role='button' 
                                    className={`fa-regular ${showPassword?'fa-eye':'fa-eye-slash'} text-white-50 position-absolute mb-0 fs-9s`} 
                                    style={{bottom: "7px", right: "10px", zIndex:"10"}}
                                    onClick={()=>setShowPassword(!showPassword)}
                                ></p>
                            </div>
                                {errorsForm2.passwordUpdate && <span className="fs-8s text-danger">{errorsForm2.passwordUpdate.message}</span>}
                        </div>
                        <div className='d-flex justify-content-center mt-4'>
                            <button 
                                className='border-0 rounded bgcolor-primary px-2 py-1 text-white fs-9s d-flex align-items-center'
                                disabled={updatePwdMutation.isPending}
                                onClick={handleSubmitForm2(modifyPwd)}
                            >
                                <i className='fa fa-pen-to-square me-2'/>
                                {updatePwdMutation.isPending ? "Chargement..." : "Modifier"}
                            </button>
                        </div>
                    </form>
                    :<p className='fs-9s text-white'>{pwdSuccess}</p>
                }

            </Modal>
        </div>
    )
}

export default Account